import React from 'react'
import { BASE_URL, SUB_URL, SUB_URL_GSM, SUB_URL_wash } from '../BaseUrl';
import axios from 'axios';

const BinLocationService = {

    BinOutward : async (bin_id, addedBy) => {
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            formData.append("added_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_wash.washing}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

    BinInward : async (bin_id, addedBy) => {
        console.log(bin_id, addedBy);
        
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            formData.append("received_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_wash.in_ward}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

    WashingBin : async (bin_id, addedBy) => {
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            formData.append("added_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_wash.outward}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

    BinOutwardWash : async (bin_id, addedBy) => {
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            formData.append("added_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_wash.outward}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

    GSM_inward : async (bin_id, addedBy) => {
        console.log(bin_id, addedBy);
        
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            formData.append("received_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_GSM.GSM_inward}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },
    GSM_outward : async (bin_id, addedBy) => {
        console.log(bin_id, addedBy);
        
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);
            // formData.append("received_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_GSM.GSM_outward}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },
    sendKanbanFinish : async (bin_id, addedBy) => {
        console.log(bin_id, addedBy);
        
        try {
            const formData = new FormData();
            formData.append("kb_number", bin_id);
            formData.append("cleared_by", addedBy);
    
            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.Kanban_Count_accuracy}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

};

export default BinLocationService